<bom-workspace>
  <ng-container *ngIf="errorMessage; else descriptionKeyMessage">
    <h1>Kvittering på digital signering</h1>
    <bom-alert
      type="error"
      titleHtml="Der skete en uventet fejl under underskrivning af dokumentationen"
      [descriptionHtml]="errorMessage"
    ></bom-alert>
  </ng-container>
  <ng-template #descriptionKeyMessage>
    <h1>{{ header }}</h1>
    <bom-alert [type]="alertType" [descriptionKey]="descriptionKey" [showIcon]="true"></bom-alert>
  </ng-template>
  <ng-container *ngIf="signering !== null">
    <button (click)="redirect()" class="button button-primary">Gå tilbage til projekt</button>
  </ng-container>
</bom-workspace>
